<template>
  <div>
    <div class="container" style="padding-top:20px;" v-if="!status && isShow">
      <div style="padding: 0 20px;">
        <h1>2022中国（杭州）国际电子商务博览会回访表</h1>
        <div v-html="desc" style="text-align:left;">

        </div>
      </div>
      <van-form @submit="onSubmit" label-align='left'>
        <!-- 自定义表单 -->

        <template v-for="(item, index) in customFiledArr">
          <div v-if="item.type == 'checkBox'" :key="index" style="border-bottom:1px solid #ebedf0;">
            <van-field class="vanCell" :name="item.type" :left-icon='item.needIcon' :label="item.label" :rules="[{ required: true, message: item.mes }]">
              <template #input>
                <van-checkbox-group v-model="item.value" :max='item.max' direction="vertical" @change="checkBoxChange(item, index, $event)">
                  <template v-for="(sitem, sindex) in item.child">
                    <van-checkbox style="margin-bottom: 10px;" :name="sitem.key" shape="square" :key="sindex">{{sitem.label}}</van-checkbox>

                  </template>
                  <van-field style="border:1px solid #ccc" :border='true' v-if="item.showInp" placeholder="请输入" v-model="item.otherWord" :rules="[{ required: true, message: '请填写' }]" />
                </van-checkbox-group>

              </template>
            </van-field>
          </div>

          <div v-if="item.type == 'input'" :key="index" style="border-bottom:1px solid #ebedf0;">
            <van-field class="vanCell" v-model="item.value" :left-icon='item.needIcon ? starIcon : ""' :label="item.label" :placeholder="item.mes" :rules="[{ required: true, message: item.mes }]" />
          </div>

          <div v-if="item.type == 'radio'" :key="index" style="border-bottom:1px solid #ebedf0;">
            <van-field class="vanCell" v-model="item.value" :left-icon='item.needIcon ? starIcon : ""' :label="item.label" :rules="[{ required: true, message: item.mes }]">
              <template #input>
                <van-radio-group v-model="item.value" @change="radioBoxChange(item, index,$event)">
                  <template v-for="(sitem, sindex) in item.child">
                    <van-radio style="margin-bottom: 10px;" :name="sitem.key" :key="sindex">{{sitem.label}}</van-radio>
                  </template>
                </van-radio-group>
              </template>
            </van-field>
          </div>

        </template>

        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>

    <div v-if='status && isShow' style="text-align:center;padding: 120px 30px 0 30px; ">
      <img src="../../../public/images/bigRight.png" alt="" style="width:64px;height:64px;">
      <div style="font-size: 22px;font-weight: 500;color: #2F2F2F;margin-top:15px;margin-bottom:35px;">
        问卷提交成功
      </div>

      <div style="width: 85vw;height: 50px;border-radius: 25px;border: 1px solid #03A64D;position:fixed;bottom: 100px;font-size: 16px;font-weight: 400;color: #fff;text-align:center;line-height:50px;background: #03A64D;" @click="goBackHome()">
        进入首页
      </div>

    </div>

  </div>

</template>


<script>
import { questionnaireAdd, checkSubmitNaire } from '../../api/questionApi'

import { GetQueryString } from '@/utils/utils'
export default {
  name: 'visitorRegister',
  data() {
    return {
      form: {
        sex: 1,
      },
      desc: `<p>
    <span style="box-sizing: inherit; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; font-size: 12px; line-height: 24px; vertical-align: middle; background: transparent;">2022年8月3-5日，由杭州市人民政府、浙江省商务厅主办，杭州市商务局承办，杭州会展集团·西博文化运营的电商中国EBE China·2022年第九届中国（杭州）国际电子商务博览会成功在杭举办。</span>
</p>
<p>
    <span style="box-sizing: inherit; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; font-size: 12px; line-height: 24px; vertical-align: middle; background: transparent;">本届大会以“新电商·新格局·新优势”为主题，汇聚数字经济和电商行业的超强阵容，全方位展示电商发展最新成果，共举办了超20场垂直于电商各领域的会议论坛活动，邀请100+直播社群短视频新渠道，吸引了近200家企业现场精准对接交流，现场累计接待观众2.5万人次，达成12个项目的战略合作签约，累计超150+媒体参与电商中国的宣传报道。</span>
</p>
<p>
    <span style="box-sizing: inherit; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; font-size: 12px; line-height: 24px; vertical-align: middle; background: transparent;">为了更好地用数字化手段提升观众的参观、参会、互动体验，我们诚挚地邀请您抽出2分钟填写本问卷。我们会从优质反馈中抽出10名用户，</span><span style="box-sizing: inherit; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; font-size: 12px; line-height: 24px; vertical-align: middle; ">给予电商中国会员（1年）8折优惠并赠送精美会刊一本，</span><span style="box-sizing: inherit; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; font-size: 12px; line-height: 24px; vertical-align: middle; background: transparent;">届时会有工作人员与您联系。</span>
</p>`,
      cascaderValue: '',
      show: false,
      starIcon: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/needForm.png',
      options: [],
      cardType: [
        {
          name: '身份证',
          key: 'CERTIFICATES_TYPE_1',
        },
        {
          name: '港澳居民来往内地通行证',
          key: 'CERTIFICATES_TYPE_2',
        },
        {
          name: '台湾居民来往大陆通行证',
          key: 'CERTIFICATES_TYPE_3',
        },
        {
          name: '外国人永久居住证',
          key: 'CERTIFICATES_TYPE_4',
        },
        {
          name: '护照',
          key: 'CERTIFICATES_TYPE_5',
        },
        {
          name: '其他',
          key: 'CERTIFICATES_TYPE_99',
        },
      ],
      columns: ['身份证', '港澳居民来往内地通行证', '台湾居民来往大陆通行证', '外国人永久居住证', '护照', '其他'],
      customFiledArr: window['AMD_USER_QUESTION'],
      isRegister: false, // 是否注册
      isShow: false,
      isHaveUserInfo: false, //用户是否有实名信息
      showPicker: false,
      status: false,
      submitFlag: false,
    }
  },
  created() {
    document.title = '2022电博会回访表'
    this.appKey = GetQueryString('appKey') || 'WX_MINI_MEHZ'
    this.eventKey = GetQueryString('eventKey') || 'MEHZ'
    this.token = GetQueryString('token')
    this.checkStatus()
  },
  methods: {
    checkStatus() {
      var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }
      checkSubmitNaire(headers, 'EBE_2022').then((res) => {
        console.log(res)
        this.status = res.data
        // this.status = false
        this.isShow = true
      })
    },
    onSubmit(e) {
      console.log(e, this.customFiledArr)
      if (this.submitFlag) {
        return false
      }

      this.submitFlag = true
      let formContentArr = []
      for (let i in this.customFiledArr) {
        let obj = {}
        obj.questionName = this.customFiledArr[i].label
        if (this.customFiledArr[i].type == 'checkBox') {
          let otherIndex = this.customFiledArr[i].valueName.findIndex((v) => v == '其他')
          if (otherIndex >= 0) {
            this.customFiledArr[i].valueName[otherIndex] = this.customFiledArr[i].otherWord
          }
          obj.questionValue = this.customFiledArr[i].valueName.join(',')
        } else {
          obj.questionValue = this.customFiledArr[i].value
        }
        formContentArr.push(obj)
      }
      console.log(JSON.stringify(formContentArr))
      var headerClientInfo = { language: 'CN', eventKey: this.eventKey, appKey: this.appKey }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }

      const data = {
        feedbackCode: 'EBE_2022',
        feedbackContent: JSON.stringify(formContentArr),
        feedbackName: '电博会',
      }

      questionnaireAdd(headers, data).then((res) => {
        console.log(res)
        // this.checkStatus()
        if (res.code == 200) {
          this.submitFlag = false
          this.status = true
        } else {
          this.submitFlag = false
          this.$toast.fail(res.msg)
        }
      })
    },
    // 返回首页
    goBackHome() {
      wx.miniProgram.navigateBack({
        delta: 1,
      })
    },
    // 监听多选框事件
    checkBoxChange(nowCheck, nowIndex, e) {
      const nowChild = nowCheck.child
      let hasCheckOther = false
      let valueName = []
      for (let i in e) {
        let checkItem = nowChild.filter((v) => v.key == e[i])
        checkItem[0].type == 'other' ? (hasCheckOther = true) : ''
        valueName.push(checkItem[0].label)
      }
      this.customFiledArr[nowIndex].showInp = hasCheckOther
      this.customFiledArr[nowIndex].valueName = valueName
    },

    radioBoxChange(nowCheck, nowIndex, e) {
      console.log(nowCheck, nowIndex, e)
      // 判断是否含有子集child，如果有加入表单
      let hasChild = nowCheck.child.filter((v) => v.key == e)[0].child
      console.log(hasChild && hasChild.length > 0)
      if (hasChild && hasChild.length > 0) {
        this.customFiledArr = this.customFiledArr.filter((v) => !v.isChildShow)
        hasChild.forEach((v) => {
          v.isChildShow = true
        })
        this.customFiledArr.push(...hasChild)
      }
    },
  },
}
</script>


<style lang="less" scoped>
.container {
  background: #fafafa;
  min-height: 100vh;
  .title {
    font-size: 14px;
    line-height: 16px;
    padding: 32px 16px 16px;
    color: rgba(69, 90, 100, 0.6);
    text-align: left;
  }
}
</style>


<style lang='less'>
.van-checkbox__label {
  width: 80vw;
}
.vantAreaCell {
  padding: 0 16px 10px 16px;
  &.van-cell::after {
    display: none;
  }
}

.vanCell {
  display: block;
  .van-field__left-icon {
    display: inline-block;
    line-height: 1;
    position: relative;
    left: -10px;
  }
  .van-field__label {
    display: inline-block;
    width: 80vw;
    position: relative;
    left: -10px;
    margin-bottom: 20px;
  }
}
</style>